import axios from '@/axios'

export default {
	namespaced: true,

	state: {
		contracts: []
	},

	actions: {
		fetchAll({ commit }, { clientId, contractNo, date, ownerIds, complete, page, perPage } = {}) {
			const params = { clientId, contractNo, date, sortByCreatedAt: true, nonDeleted: true, complete, page, perPage };
			const urlSearchParams = new URLSearchParams();
			Object.keys(params).forEach(key => {
				if (params[key]) urlSearchParams.append(key, params[key]);
			});
			if (Array.isArray(ownerIds)) {
				ownerIds.forEach(id => urlSearchParams.append('ownerIds', id));
			}
			return axios.get('/delivery', {
				params: urlSearchParams
			});
		},
		fetchById({ commit }, { id }) {
			return axios.get(`/delivery/${id}`);
		},

		create({ commit }, { contractNo, contractId, date, clientId, sale, items }) {
			return axios.post('/delivery', { contractNo, contractId, date, isDelivered: false, clientId, sale, items });
		},

		update({ commit }, { id, contractNo, contractId, date, clientId, sale, items }) {
			return axios.put(`/delivery/${id}`, { contractNo, contractId, date, isDelivered: false, clientId, sale, items });
		},

		updateStatus({ commit }, { id, isDelivered }) {
			return axios.put(`/delivery/${id}/status`, `${isDelivered}`, {
				headers: { 'Content-Type': 'application/json' }
			});
		},

		delete({ commit }, { id }) {
			return axios.delete(`/delivery/${id}`);
		}
	},
}